import { formActionsForPermissions } from '../../../actions/customer/CustomerAction';
import { workspaceForPermissions } from '../../../actions/customer/CustomerWorkspaceAction';
import { EntityType } from '../../../@types/entityTypes';

const CreditControl: EntityType = {
  type: 'Customer',
  title: 'Credit Control',
  formTitle: 'Credit Control',
  formUrl: '/Customers/Customer/Details/',
  workspaceUrl: '/Customers/CreditControl/Workspace/',
  screenReference: 'CUSTOMER_CREDIT_CONTROL',
  actions: [...formActionsForPermissions, ...workspaceForPermissions],
};

export default CreditControl;
